export default __webpack_public_path__ + "static/media/mint_ufo.211d946e.png";